"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfContainedCacheAsync = exports.SelfContainedCache = exports.Cache = exports.CacheBase = void 0;
const add_minutes_1 = require("../functions/add-minutes");
class CacheBase {
    constructor(cacheLifeInMinute = 30) {
        this.cacheLifeInMinute = cacheLifeInMinute;
    }
    set(value) {
        this.cachedValue = value;
        this.expires = add_minutes_1.addMinutes(new Date(), this.cacheLifeInMinute);
        return this.cachedValue;
    }
    getCachedItem() {
        const cacheIsStale = !this.expires
            || new Date().valueOf() > this.expires.valueOf();
        if (cacheIsStale) {
            this.cachedValue = undefined;
        }
        return this.cachedValue;
    }
}
exports.CacheBase = CacheBase;
class Cache extends CacheBase {
    get value() {
        return this.getCachedItem();
    }
}
exports.Cache = Cache;
class SelfContainedCache extends CacheBase {
    constructor(getValue, cacheLifeInMinute = 30) {
        super(cacheLifeInMinute);
        this.getValue = getValue;
    }
    get value() {
        return this.getCachedItem() || this.setCachedValue();
    }
    setCachedValue() {
        this.cachedValue = this.getValue();
        this.expires = add_minutes_1.addMinutes(new Date(), this.cacheLifeInMinute);
        return this.cachedValue;
    }
}
exports.SelfContainedCache = SelfContainedCache;
class SelfContainedCacheAsync extends CacheBase {
    constructor(getValue, cacheLifeInMinute = 30) {
        super(cacheLifeInMinute);
        this.getValue = getValue;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getCachedItem() || (yield this.setCachedValue());
        });
    }
    setCachedValue() {
        return __awaiter(this, void 0, void 0, function* () {
            this.cachedValue = yield this.getValue();
            this.expires = add_minutes_1.addMinutes(new Date(), this.cacheLifeInMinute);
            return this.cachedValue;
        });
    }
}
exports.SelfContainedCacheAsync = SelfContainedCacheAsync;
